const config = {
  name: "northstar",
  features: {
    accessCodes: true,
    moreInformation: true,
    hasParkingInstructions: true,
    hasPromoCodeWarning: false,
    userPhoneNumber: false,
    userName: false,
    showAdaSupport: true
  },
  parkingSession: {
    // The same day, just before 8am
    cancelDaysBefore: 0,
    cancelTime: "08:00",
    cancelTimeOptions: [],
    // Start time offset from midnight, i.e. 6 am
    startOffsetHrs: 6,
    // Start date offset from today (0 = today)
    startOffsetDate: 0,
    // End date offset from start time
    endOffsetDate: 300
  }
}
export default config
